// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import type {
  HasImages,
  MaybeAToMaybeAB,
  PinImage,
} from 'app/common/react/components/closeup/utils/types';

type HasImage236x = {
  image236x: PinImage,
};
type HasImage564x = {
  image564x: PinImage,
};
type HasImage736x = {
  image736x: PinImage,
};
type ToMaybeHasImage236x = MaybeAToMaybeAB<HasImages, HasImage236x>;
type ToMaybeHasImage564x = MaybeAToMaybeAB<HasImages, HasImage564x>;
type ToMaybeHasImage736x = MaybeAToMaybeAB<HasImages, HasImage736x>;

const hasImageSize = (size) => (props) => {
  const { images } = props;
  const imageAtSize = images[size];
  const { url, width, height } = imageAtSize || {};
  return url && !!width && !!height ? { url, width, height } : null;
};

export const hasImage236x: ToMaybeHasImage236x = createMaybeTransform((props) => {
  const image236x = hasImageSize('236x')(props);
  return image236x && { ...props, image236x };
});

export const hasImage564x: ToMaybeHasImage564x = createMaybeTransform((props) => {
  const image564x = hasImageSize('564x')(props);
  return image564x && { ...props, image564x };
});

export const hasImage736x: ToMaybeHasImage736x = createMaybeTransform((props) => {
  const image736x = hasImageSize('736x')(props);
  return image736x && { ...props, image736x };
});

export default null;
